import cn from 'classnames';
import React, { memo } from 'react';
import { Tab } from './Tab';
import styles from './Tabs.scss';
import { ITabsProps } from './Tabs.types';

export const Tabs: React.FC<ITabsProps> = memo(({ className, focusedIdx, tabClassName, tabs, onChange }) => {
    return (
        <div className={cn(styles.tabs, className)}>
            {tabs.map((tab, i) => (
                <Tab
                    key={`tab_${tab.id}`}
                    className={tabClassName}
                    isFocused={focusedIdx === i}
                    onPointerDown={() => onChange(i)}
                    title={tab.titleComponent ? tab.titleComponent : tab.title}
                />
            ))}
        </div>
    );
});
